export type Lang = 'he' | 'ru' | 'en';

export const LANGS: { code: Lang; label: string; dir: 'rtl' | 'ltr' }[] = [
  { code: 'he', label: 'עברית', dir: 'rtl' },
  { code: 'ru', label: 'Русский', dir: 'ltr' },
  { code: 'en', label: 'English', dir: 'ltr' },
];

export type Dict = Record<string, string>;

export const TRANSLATIONS: Record<Lang, Dict> = {
  he: {
    'app.title': 'Draw — ציור על PDF ותמונות',
    'picker.sub': 'ציור על PDF ותמונות — באצבע או בעט',
    'picker.pick': 'בחירת קובץ',
    'picker.library': 'מהספרייה',
    'picker.libraryTitle': 'בחר מסמך מהספרייה',
    'picker.libraryEmpty': 'הספרייה ריקה',
    'picker.libraryLoading': 'טוען ספרייה…',
    'picker.libraryError': 'לא ניתן לטעון את הספרייה',
    'picker.libraryClose': 'סגור',
    'picker.loading': 'טוען…',
    'picker.hint': 'הקובץ נשאר במכשיר. הציור נשמר אוטומטית בדפדפן.',
    'picker.error.unsupported': 'נתמכים רק קבצי PDF ותמונות',
    'picker.error.notInLibrary': 'הקובץ לא נמצא בספרייה',
    'tool.pen': 'עט',
    'tool.eraser': 'מחק',
    'tool.undo': 'בטל',
    'tool.clearPage': 'נקה דף',
    'tool.clearAll': 'נקה הכל',
    'tool.exportPng': 'PNG',
    'tool.exportPdf': 'PDF',
    'tool.close': 'סגור',
    'tool.zoomIn': 'הגדל',
    'tool.zoomOut': 'הקטן',
    'tool.zoomReset': 'התאם',
    'tool.fullscreen': 'מסך מלא',
    'tool.exitFullscreen': 'יציאה ממסך מלא',
    'nav.prev': 'הקודם',
    'nav.next': 'הבא',
    'nav.games': 'למשחקים',
    'submit.button':       'שליחה',
    'submit.title':        'שליחת ציור',
    'submit.parentName':   'שם ההורה',
    'submit.parentPhone':  'טלפון ההורה',
    'submit.childName':    'שם הילד',
    'submit.childAge':     'גיל הילד',
    'submit.send':         'שלח',
    'submit.cancel':       'ביטול',
    'submit.sending':      'שולח…',
    'submit.success':      'הציור נשלח בהצלחה',
    'submit.fail':         'השליחה נכשלה',
    'submit.missingFields':'נא למלא את כל השדות',
    'submit.invalidPhone': 'מספר טלפון חייב להיות 10 ספרות בפורמט 05XXXXXXXX',
    'submit.invalidAge':   'גיל הילד — רק ספרות',
    'hw.confirm.title':    'לשלוח את שיעורי הבית?',
    'hw.confirm.text':     'הציור יישלח למורה. לאחר מכן לא ניתן לבטל.',
    'hw.confirm.yes':      'שלח למורה',
    'hw.sent':             '✓ נשלח',
    'hw.signatureRequired':'נדרשת חתימה תקפה',
    'hw.signatureInvalid': 'חתימה לא תקפה',
    'confirm.clearAll': 'למחוק את כל הציורים במסמך?',
    'confirm.yes': 'מחק',
    'confirm.no': 'ביטול',
    'page.loading': 'טוען עמוד…',
    'page.error': 'שגיאה בטעינת העמוד',
    'lang.label': 'שפה',
    'fullscreen.iosTitle': 'מסך מלא ב-iPhone',
    'fullscreen.iosHint': 'פתח את האתר ב-Safari, לחץ על "שתף" ובחר "הוסף למסך הבית" — כך תקבל מסך מלא ללא שורת כתובת.',
  },
  ru: {
    'app.title': 'Draw — рисование поверх PDF и картинок',
    'picker.sub': 'Рисование поверх PDF и картинок — пальцем или стилусом',
    'picker.pick': 'Выбрать файл',
    'picker.library': 'Из библиотеки',
    'picker.libraryTitle': 'Выберите документ из библиотеки',
    'picker.libraryEmpty': 'Библиотека пуста',
    'picker.libraryLoading': 'Загружаю библиотеку…',
    'picker.libraryError': 'Не удалось загрузить библиотеку',
    'picker.libraryClose': 'Закрыть',
    'picker.loading': 'Загружаю…',
    'picker.hint': 'Файл остаётся на устройстве. Разметка автоматически сохраняется в браузере.',
    'picker.error.unsupported': 'Поддерживаются только PDF и изображения',
    'picker.error.notInLibrary': 'Файл не найден в библиотеке',
    'tool.pen': 'Перо',
    'tool.eraser': 'Ластик',
    'tool.undo': 'Отменить',
    'tool.clearPage': 'Очистить стр.',
    'tool.clearAll': 'Очистить всё',
    'tool.exportPng': 'PNG',
    'tool.exportPdf': 'PDF',
    'tool.close': 'Закрыть',
    'tool.zoomIn': 'Приблизить',
    'tool.zoomOut': 'Отдалить',
    'tool.zoomReset': 'Вписать',
    'tool.fullscreen': 'На весь экран',
    'tool.exitFullscreen': 'Выйти из полноэкранного',
    'nav.prev': 'Назад',
    'nav.next': 'Вперёд',
    'nav.games': 'К играм',
    'submit.button':       'Отправить',
    'submit.title':        'Отправить рисунок',
    'submit.parentName':   'Имя родителя',
    'submit.parentPhone':  'Телефон родителя',
    'submit.childName':    'Имя ребёнка',
    'submit.childAge':     'Возраст ребёнка',
    'submit.send':         'Отправить',
    'submit.cancel':       'Отмена',
    'submit.sending':      'Отправляю…',
    'submit.success':      'Рисунок отправлен',
    'submit.fail':         'Не удалось отправить',
    'submit.missingFields':'Заполните все поля',
    'submit.invalidPhone': 'Телефон должен быть 10 цифр в формате 05XXXXXXXX',
    'submit.invalidAge':   'Возраст ребёнка — только цифры',
    'hw.confirm.title':    'Отправить домашнее задание?',
    'hw.confirm.text':     'Рисунок будет отправлен учителю. Отменить нельзя.',
    'hw.confirm.yes':      'Отправить учителю',
    'hw.sent':             '✓ Отправлено',
    'hw.signatureRequired':'Нужна действительная подпись',
    'hw.signatureInvalid': 'Недействительная подпись',
    'confirm.clearAll': 'Удалить всю разметку для этого документа?',
    'confirm.yes': 'Удалить',
    'confirm.no': 'Отмена',
    'page.loading': 'Загрузка страницы…',
    'page.error': 'Ошибка загрузки страницы',
    'lang.label': 'Язык',
    'fullscreen.iosTitle': 'Полный экран на iPhone',
    'fullscreen.iosHint': 'Откройте этот сайт в Safari, нажмите «Поделиться» и выберите «На экран Домой» — получите fullscreen без адресной строки.',
  },
  en: {
    'app.title': 'Draw — annotate PDFs and images',
    'picker.sub': 'Annotate PDFs and images with finger or stylus',
    'picker.pick': 'Choose file',
    'picker.library': 'From library',
    'picker.libraryTitle': 'Choose a document from the library',
    'picker.libraryEmpty': 'Library is empty',
    'picker.libraryLoading': 'Loading library…',
    'picker.libraryError': 'Failed to load library',
    'picker.libraryClose': 'Close',
    'picker.loading': 'Loading…',
    'picker.hint': 'The file stays on your device. Drawings are saved automatically in the browser.',
    'picker.error.unsupported': 'Only PDF and images are supported',
    'picker.error.notInLibrary': 'File not found in library',
    'tool.pen': 'Pen',
    'tool.eraser': 'Eraser',
    'tool.undo': 'Undo',
    'tool.clearPage': 'Clear page',
    'tool.clearAll': 'Clear all',
    'tool.exportPng': 'PNG',
    'tool.exportPdf': 'PDF',
    'tool.close': 'Close',
    'tool.zoomIn': 'Zoom in',
    'tool.zoomOut': 'Zoom out',
    'tool.zoomReset': 'Fit',
    'tool.fullscreen': 'Fullscreen',
    'tool.exitFullscreen': 'Exit fullscreen',
    'nav.prev': 'Prev',
    'nav.next': 'Next',
    'nav.games': 'To games',
    'submit.button':       'Send',
    'submit.title':        'Send drawing',
    'submit.parentName':   'Parent name',
    'submit.parentPhone':  'Parent phone',
    'submit.childName':    'Child name',
    'submit.childAge':     'Child age',
    'submit.send':         'Send',
    'submit.cancel':       'Cancel',
    'submit.sending':      'Sending…',
    'submit.success':      'Drawing sent',
    'submit.fail':         'Send failed',
    'submit.missingFields':'Please fill all fields',
    'submit.invalidPhone': 'Phone must be 10 digits in format 05XXXXXXXX',
    'submit.invalidAge':   'Child age — digits only',
    'hw.confirm.title':    'Send homework?',
    'hw.confirm.text':     'Drawing will be sent to the teacher. Cannot be undone.',
    'hw.confirm.yes':      'Send to teacher',
    'hw.sent':             '✓ Sent',
    'hw.signatureRequired':'Valid signature required',
    'hw.signatureInvalid': 'Invalid signature',
    'confirm.clearAll': 'Delete all annotations for this document?',
    'confirm.yes': 'Delete',
    'confirm.no': 'Cancel',
    'page.loading': 'Loading page…',
    'page.error': 'Failed to load page',
    'lang.label': 'Language',
    'fullscreen.iosTitle': 'Fullscreen on iPhone',
    'fullscreen.iosHint': 'Open this site in Safari, tap Share, then "Add to Home Screen" — you\'ll get fullscreen without the address bar.',
  },
};
